import {ReactComponent as SettingsIcon} from "../assets/fonts/feather/settings.svg";
import Loader from "./Loader";
import React, {useEffect, useRef, useState} from "react";
import {ReactComponent as MoveIcon} from "../assets/fonts/feather/move.svg";
import Modal from "./Modal";
import {ContextMenu} from 'primereact/contextmenu'
import {Checkbox} from "primereact/checkbox";
import {Dropdown} from "primereact/dropdown";
import TableComment from "./TableComment";
import {Dialog} from "primereact/dialog";
import {Badge} from "primereact/badge";
import {Link} from "react-router-dom";


function TableView(props) {


    const [settingsVisible, setSettingsVisible] = useState(false)
    const [deleteVisible, setDeleteVisible] = useState(false)
    const menuRight = useRef(null);

    const [checkedRows, setCheckedRows] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const [massAction, setMassAction] = useState(false);

    const onCheckedRowsChange = (e) => {
        let _checkedRows = [...checkedRows];

        if (e.checked)
            _checkedRows.push(e.value);
        else
            _checkedRows.splice(_checkedRows.indexOf(e.value), 1);

        setCheckedRows(_checkedRows);
    }

    const handleTableSettings = (e) => {
        e.preventDefault()
        setSettingsVisible(true);
    }
    const handleHideTableSettings = () => setSettingsVisible(false)


    let dragged;
    let nodePlacement;
    let over;
    let placeholder = document.createElement("div");
    let rowActions = [];
    placeholder.className = "form-check placeholder";

    const settingsDragStart = (e) => {
        dragged = e.currentTarget
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData("text/html", e.currentTarget);
        dragged.style.background = '#fff'
        // dragged.style.paddingLeft = '10px'
        // dragged.style.paddingRight = '10px'
    }

    const settingsDragEnd = (e) => {
        dragged.style.display = "flex";
        dragged.parentNode.removeChild(placeholder);

        // Update state
        const data = [...props.tableRows];
        const from = Number(dragged.dataset.id);
        let to = Number(over.dataset.id);
        if (from < to) to--;
        // Inside dragEnd method
        if (nodePlacement === "after") to++;
        data.splice(to, 0, data.splice(from, 1)[0]);
        // console.log(data)
        props.setTableRows(data)

        localStorage.setItem('table-' + props.id, JSON.stringify(data))
    }

    const settingsDragOver = (e) => {
        e.preventDefault();


        // this.dragged.style.display = "none";
        dragged.style.display = 'none';
        if (e.target.className === "placeholder") return;
        if (e.target.className !== "form-check checkbox") return;
        over = e.target;

        // Inside the dragOver method
        var relY = e.clientY - over.offsetTop;
        var height = over.offsetHeight / 2;
        var parent = e.target.parentNode;
        if (relY > height) {
            nodePlacement = "after";
            parent.insertBefore(placeholder, e.target.nextElementSibling);
        } else if (relY < height) {
            nodePlacement = "before"
            parent.insertBefore(placeholder, e.target);
        }


    }

    const changeTableSettings = (event) => {
        let data = [...props.tableRows];
        data[event.target.dataset.id].selected = !data[event.target.dataset.id].selected
        props.setTableRows(data)

        localStorage.setItem('table-' + props.id, JSON.stringify(data))
    }


    useEffect(() => {
        setCheckAll(false)
        setCheckedRows([])
    }, [props.data])

    const checkAllHandler = (e) => {
        if (checkAll) {
            setCheckedRows([])
        } else {
            setCheckedRows(
                props.data.items.map((el) => {
                    return el.id
                })
            )
        }

        setCheckAll(!checkAll)
    }

    const tableValue = (propName, el) => {
        switch (propName) {

            default:
                return (
                    el[propName]
                )
        }
    }

    return (
        <>

            <Dialog header={'Настройка таблицы'} style={{width: '50vw'}} visible={settingsVisible}
                    onHide={handleHideTableSettings}>
                <p>Выберите и отсортируйте нужные поля</p>
                {props.tableRows ?
                    props.tableRows.map((row, i) => {
                        return (
                            <div className="form-check checkbox" data-id={i} draggable="true"
                                 onDragEnd={settingsDragEnd} key={'table-view-settings-' + i}
                                 onDragStart={settingsDragStart} onDragOver={settingsDragOver}>
                                <input type="checkbox" id={'table-setting-row-' + row.name} className="form-check-input"
                                       data-id={i} name={row.name} defaultChecked={row.selected ? row.selected : false}
                                       onChange={changeTableSettings}/>

                                <label htmlFor={'table-setting-row-' + row.name}
                                       className="form-check-label">{row.label}</label>
                                <MoveIcon className={'row-move-icon'}/>
                            </div>
                        )
                    }) : <p>Нет полей для редактирования.</p>}
            </Dialog>

            <div className="table-responsive">

                <form action="" className={'theme-form'}>
                    <table className={'table table-styling ' + props.tableClass}>
                        {!props.hideHead &&
                        <thead>
                        <tr>
                            {props.massRowActions &&
                                <th className={'first-check-column'}>
                                    {/*<div className="form-check checkbox mb-0">*/}
                                    {/*    <input className="form-check-input" id={"checkbox-90"} type="checkbox"/>*/}
                                    {/*    <label className="form-check-label" htmlFor={"checkbox-90"}>&nbsp;</label>*/}
                                    {/*</div>*/}
                                    <div className="form-check">
                                        <Checkbox value={true} onChange={checkAllHandler} checked={checkAll}/>
                                    </div>
                                </th>
                            }
                            {props.tableRows.map((row, k) => {
                                if (row.selected) {
                                    return (
                                        <th key={'table-th-' + k}>{row.label}</th>
                                    )
                                }
                            })}
                            <th className={'table__last-th'}>
                                {!props.hideSettings &&
                                <button className={'btn btn-default table__settings'} onClick={handleTableSettings}>
                                    <SettingsIcon/>
                                </button>
                                }
                            </th>
                        </tr>
                        </thead>
                        }

                        {props.data && (props.data.items.length > 0) &&
                            <tbody>
                            {props.data.items && props.data.items.map((el, k) => {

                                return (
                                    <React.Fragment key={k}>
                                        <tr onContextMenu={(event) => {
                                            if (props.rowActionsHandler) {
                                                menuRight.current.props.model = props.rowActionsHandler(el.id);
                                                menuRight.current.show(event)
                                            } else return false
                                        }}
                                            className={((el.comments && el.comments.length > 0) ? 'without-bb' : '') + (el.read === 0 ? ' new' : '')}>

                                            {props.massRowActions &&
                                                <td className={'first-check-column'}>
                                                    {/*{!el.read ? <Badge value={'Новая'}/> : ''}*/}
                                                    <div className="form-check">
                                                        <Checkbox inputId={'check-row-' + k} value={el.id}
                                                                  onChange={onCheckedRowsChange}
                                                                  checked={checkedRows.includes(el.id)}/>
                                                    </div>
                                                </td>
                                            }
                                            {props.tableRows.map((row, indexRow) => {
                                                if (row.selected) {
                                                    return (
                                                        <td key={'table-rows-c-' + indexRow}>
                                                            {props.tableValue ? props.tableValue(row.name, el) : tableValue(row.name, el)}
                                                        </td>
                                                    )
                                                }
                                            })}


                                            <td>
                                                <div className="table__actions">

                                                    <div>
                                                        {props.rowActionsHandler && <>
                                                            <ContextMenu model={props.rowActions} ref={menuRight}
                                                                         breakpoint="767px"/>
                                                            {/*<Menu model={props.rowActions} key={el.id} popup ref={menuRight} id={"popup_menu_right-" + k} />*/}
                                                            <button type={'button'}
                                                                    className="mr-2 btn btn-default btn-square"
                                                                    onClick={(event) => {
                                                                        menuRight.current.props.model = props.rowActionsHandler(el.id);
                                                                        menuRight.current.show(event)
                                                                    }} aria-controls={"popup_menu_right-" + k}
                                                                    aria-haspopup><i
                                                                className="icon-more"></i></button>
                                                        </>
                                                        }
                                                    </div>


                                                </div>
                                            </td>
                                        </tr>
                                        {el.comments && el.comments.length > 0 && <tr className={'table-comments-row'}>
                                            <td colSpan={props.tableRows.length + 2}>
                                                <div className="table-comments d-flex flex-wrap gap-3">
                                                    {el.comments.map((comment, commentIndex) => {
                                                        return <TableComment key={commentIndex} model={comment}/>
                                                    })}
                                                </div>
                                            </td>
                                        </tr>}
                                    </React.Fragment>
                                )
                            })}
                            </tbody>
                        }
                    </table>


                </form>

                {(!props.data || !props.data.items.length) ?
                    <p className={'m-30 d-flex justify-content-center'}>Нет данных</p> : ''}


                {props.loading && <Loader/>}

                {checkedRows.length > 0 &&
                    <div className="footer footer-fix">
                        <div className="container-fluid">
                            <div className="row align-items-center">
                                <div className="col-6">
                                    <div className="d-flex">
                                        <Dropdown options={props.massRowActions} itemTemplate={(e) => <div><span
                                            className={e.icon + ' m-r-10'}></span>{e.label}</div>}
                                                  placeholder={'Выберите действие'} value={massAction}
                                                  onChange={(e) => setMassAction(e.value)}/>
                                        <button className={'btn btn-primary m-l-15 flex-shrink-0'}
                                                onClick={(e) => props.massActionHander(massAction, checkedRows)}>Применить
                                        </button>

                                        <button className={'btn btn-outline-danger m-l-15'} onClick={(e) => {
                                            setCheckedRows([]);
                                            setCheckAll(false)
                                        }}>Отмена
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>
        </>

    )

}

export default TableView